module.exports = __webpack_public_path__ + "img/2014pigc.d6fc4486.png";